import { render } from "./aio-login-form.vue?vue&type=template&id=01eded8a"
import script from "./aio-login-form.vue?vue&type=script&lang=js"
export * from "./aio-login-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__